export const LEAGUE_FIELDS = `
  fragment leagueFields on League {
	_id
	logo
	name
	description
	website
	email
	country
	clubs
  }
`;

export const LEAGUE_WITH_CLUBS_FIELDS = `
  fragment leagueWithClubsFields on LeagueWithClubs {
    _id
    logo
    name
    description
    website
    email
    country
    clubs {
      _id
      name
      linkName
    }
    clubsCount
  }
`;

export const COMPETITION_FIELDS = `
  fragment competitionFields on Competition {
    _id
    leagueId
	  ageGroup
    gender
	  name
	  startYear
    duration
    scrapUrls
	  teams
  }
`;

export const COMPETITION_WITH_TEAMS_FIELDS = `
  fragment competitionWithTeamsFields on CompetitionWithTeams {
    _id
    leagueId
    ageGroup
    gender
    name
    startYear
    duration
    scrapUrls
    teams {
      _id
      name
      club
    }
    teamsCount
  }
`;

export const FIXTURE_FIELDS = `
  fragment fixtureFields on Fixture {
	_id
	fixtureName
	leagueId
	competitionId
  }
`;

export const MATCH_FIELDS = `
  fragment matchFields on Match {
    _id
    homeTeam
    awayTeam
    date
    time
    venue
    status
    score {
      home
      away
    }
    location {
      address
      coordinates
      type
    }
    competitionId
    competitionName
    scoreLocked
    fixtureId
    fixtureName
    leagueId
  }
`;

export const FIXTURE_WITH_MATCHES_FIELDS = `
${MATCH_FIELDS}
  fragment fixtureWithMatchesFields on FixtureWithMatches {
    _id
    competitionName
    fixtureName
    leagueId
    competitionId
    matches {
      ...matchFields
    }   
  }
`;

export const CREATE_LEAGUE_FULL = `
  mutation (
    $league: LeagueInput
    $competitions: [CompetitionWithFixturesAndMatchesInput]
  ) {
    createLeagueFull(
      league: $league
      competitions: $competitions
    ) {
      league {
        _id
      logo
      name
      description
      website
      email
      country
      clubs
      }
      competitions {
        _id
        leagueId
        ageGroup
        gender
        name
        startYear
        duration
        teams
      }
      fixtures {
        _id
        fixtureName
        leagueId
        competitionId
      }
      matches {
        _id
        homeTeam
        awayTeam
        date
        time
        venue
        location {
          address
          coordinates
          type
        }
        status
        score {
          home
          away
        }
        competitionId
        fixtureId
        leagueId
      }
    }
  }
`;

export const GET_LEAGUES_FULL = `
  query ($clubId: String) {
    getLeaguesFull(clubId: $clubId) {
      league {
        _id
        logo
        name
        description
        website
        email
        country
        clubs
      }
      competitions {
        _id
        leagueId
        ageGroup
        gender
        name
        startYear
        duration
        teams
        fixtures {
          _id
          fixtureName
          leagueId
          competitionId
          matches {
            _id
            homeTeam
            awayTeam
            date
            time
            venue
            location {
              type
              address
              coordinates
            }
            status
            score {
              home
              away
            }
            leagueId
            competitionId
            fixtureId 
          }
        }
      }
    }
  }
`;

export const GET_LEAGUES = `
${LEAGUE_FIELDS}
  query ($term: String, $clubId: String, $leagueIds: [String], $skip: Int, $limit: Int) {
    getLeagues(term: $term, clubId: $clubId, leagueIds: $leagueIds, skip: $skip, limit: $limit) {
      ...leagueFields
    }
  }
`;

export const GET_LEAGUES_WITH_CLUBS = `
${LEAGUE_WITH_CLUBS_FIELDS}
  query ($term: String, $leagueIds: [String], $skip: Int, $limit: Int) {
    getLeaguesWithClubs(term: $term, leagueIds: $leagueIds, skip: $skip, limit: $limit) {
      ...leagueWithClubsFields
    }
  }
`;

export const GET_COMPETITIONS = `
${COMPETITION_FIELDS}
  query ($leagueIds: [String], $term: String, $clubId: String, $competitionIds: [String], $skip: Int, $limit: Int) {
    getCompetitions(leagueIds: $leagueIds, term: $term, clubId: $clubId, competitionIds: $competitionIds, skip: $skip, limit: $limit) {
      ...competitionFields
    }
}`;

export const GET_COMPETITIONS_WITH_TEAMS = `
${COMPETITION_WITH_TEAMS_FIELDS}
  query ($leagueIds: [String], $term: String, $competitionIds: [String], $skip: Int, $limit: Int) {
    getCompetitionsWithTeams(leagueIds: $leagueIds, term: $term, competitionIds: $competitionIds, skip: $skip, limit: $limit) {
      ...competitionWithTeamsFields
    }
  }
`;

export const GET_FIXTURES = `
${FIXTURE_FIELDS}
  query ($leagueId: String, $competitionId: String, $fixtureIds: [String]){
    getFixtures(leagueId: $leagueId, competitionId: $competitionId, fixtureIds: $fixtureIds) {
      ...fixtureFields
    }
  }
`;

export const GET_MATCHES = `
${MATCH_FIELDS}
  query($fixtureId: String!, $leagueId: String, $competitionId: String, $matchIds: [String]) {
    getMatches(
      fixtureId: $fixtureId,
      leagueId: $leagueId,
      competitionId: $competitionId,
      matchIds: $matchIds
    ) {
      ...matchFields
    }
  }
`;

export const GET_FIXTURES_FULL = `
${FIXTURE_WITH_MATCHES_FIELDS}
  query ($competitionId: String!, $leagueId: String, $fixtureIds: [String], $matchIds: [String], $term: String, $skip: Int, $limit: Int) {
    getFixturesFullAdmin(competitionId: $competitionId, leagueId: $leagueId, fixtureIds: $fixtureIds, matchIds: $matchIds, term: $term, skip: $skip, limit: $limit) {
      ...fixtureWithMatchesFields
    }
  }
`;

export const CREATE_LEAGUE = `
${LEAGUE_FIELDS}
  mutation ($league: LeagueInput) {
    createLeague(league: $league) {
      ...leagueFields
    }
  }
`;

export const EDIT_LEAGUE = `
${LEAGUE_FIELDS}
  mutation (
    $leagueId: String!
    $league: LeagueInput
  ) {
    editLeague(
      leagueId: $leagueId
      league: $league
    ) {
      ...leagueFields
    }
  }
`;

export const DELETE_LEAGUE = `
  mutation ($leagueId: String!) {
    deleteLeague(leagueId: $leagueId)
  }
`;

export const CREATE_COMPETITION = `
${COMPETITION_FIELDS}
  mutation ($competition: CompetitionInput) {
    createCompetition(competition: $competition) {
      ...competitionFields
    }
  }
`;

export const EDIT_COMPETITION = `
${COMPETITION_FIELDS}
  mutation (
    $competitionId: String!
    $competition: CompetitionInput
  ) {
    editCompetition(
      competitionId: $competitionId
      competition: $competition
    ) {
      ...competitionFields
    }
  }
`;

export const DELETE_COMPETITION = `
  mutation ($competitionId: String!) {
    deleteCompetition(competitionId: $competitionId)
  }
`;

export const CREATE_FIXTURE = `
  ${FIXTURE_FIELDS}
  mutation ($fixture: FixtureInput) {
    createFixture(fixture: $fixture) {
      ...fixtureFields
    }
  }
`;

export const EDIT_FIXTURE = `
${FIXTURE_FIELDS}
  mutation ($fixtureId: String!, $fixture: FixtureInput) {
    editFixture(fixtureId: $fixtureId, fixture: $fixture) {
      ...fixtureFields
    }
  }
`;

export const DELETE_FIXTURE = `
  mutation ($fixtureId: String!) {
    deleteFixture(fixtureId: $fixtureId)
  }
`;

export const REORDER_FIXTURES = `
  mutation ReorderFixtures($fixtures: [FixtureReorderInput!]!) {
    reorderFixtures(fixtures: $fixtures)
  }
`;

export const CREATE_MATCH = `
${MATCH_FIELDS}
  mutation (
    $match: MatchInput
  ) {
    createMatch(match: $match) {
      ...matchFields
    }
  }
`;

export const EDIT_MATCH = `
${MATCH_FIELDS}
  mutation (
    $matchId: String!
    $match: MatchInput
  ) {
    editMatch(
      matchId: $matchId
      match: $match
    ) {
      ...matchFields
    }
  }
`;

export const DELETE_MATCH = `
  mutation ($matchId: String!) {
    deleteMatch(matchId: $matchId)
  }
`;

export const BULK_SAVE_SCHEDULE = `
  mutation BulkSaveSchedule($input: BulkScheduleInput!) {
    bulkSaveSchedule(input: $input) {
      ok
      fixtures {
        _id
        fixtureName
        competitionId
        leagueId
        order
      }
      matches {
        _id
        homeTeam
        awayTeam
        date
        time
        venue
        status
        score { home away }
        scoreLocked
        fixtureId
        fixtureName
        competitionId
        leagueId
      }
    }
  }
`;
